export const UPDATE_CITY_DATA='CITYPAGE/UPDATE_CITY_DATA'